import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

export function LowValueTransactionDialog() {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'attention'} />}}>
                Warning: Unusual low-value transaction
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body align={'left'}>
                <div className={'fv-text-m-regular space-y-2 rounded-[10px] bg-neutral-20 p-5 text-neutral-90'}>
                    <div>This transaction involves an unusually small amount.</div>
                    <div>
                        Such transfers may be used for suspicious or malicious purposes, including attempts to analyze
                        and link wallet activity.
                    </div>
                    <div>
                        Please verify that this transaction belongs to you and avoid interacting with unknown small
                        amounts. If you have any questions, contact{' '}
                        <a href='mailto:support@raison.app' className={'text-primary-30'}>
                            support@raison.app
                        </a>
                        .
                    </div>
                </div>
            </RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike intent={'secondary'} as={RsnDialog.CloseTrigger}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
